<template>
<div class="dictionary-field">
    <div class="dictionary-field__title">{{title}}</div>
    <div class="horizontal-risk-line">
        <div v-bind:class="{'horizontal-risk-line--low': isLow, 'horizontal-risk-line--medium': isMedium, 'horizontal-risk-line--high': isHigh}"></div>
    </div>
    <div class="horizontal-risk-line__text">
        <span v-if="isHigh">High</span>
        <span v-else-if="isMedium">Medium</span>
        <span v-else>Low</span>
    </div>
</div>
</template>

<style scoped>
    .horizontal-risk-line div {
        width: 5rem;
    }
</style>


<script>
    export default {
        name: "UXRiskBar",
        props: {
            isLow: Boolean,
            isMedium: Boolean,
            isHigh: Boolean,
            title: String
        },
        computed: {}
    };
</script>
